import * as types from '../constants/ActionTypes'

let defaultState = {
    items: [],
    checkUpload: {},
    video_percentage: null
}

export default function app(state = defaultState, action){
    switch(action.type){
        case types.RESET_GALLERY_STATE:
            return state = defaultState;

        case types.SET_GALLERY_ITEMS_FOR_PATIENT:
            // console.log("REDUCERS", action, state)
            // console.log(action.payload);
            return {...state, items: action.payload}
            
        case types.SET_GALLERY_BY_ID:
            // console.log("REDUCERS", action, state)
            return {...state, checkUpload: action.payload}
        
        case types.SET_VIDEO_UPLOAD_PERCENTAGE:
            // console.log("REDUCERS", action, state)
            return {...state, video_percentage: action.payload}
        
        default:
            // console.log("RESETTING MEDIA UPLOAD STATE")
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/gallery.js